import { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Poster_create,
  Poster_update,
  Avatar_create,
  Avatar_update,
  Categories_create,
  Categories_update,
  Devices_create,
  Devices_update,
  Genres_create,
  Genres_update,
  getAvatarGender,
  getPeerGroups,
  getUserGroup,
  Languages_create,
  Languages_update,
  MatuarityRatings_create,
  MatuarityRatings_update,
  Theme_create,
  Theme_update,
  Languages_list,
  Categories_list,
  Genres_list,
  Language_Lists,
  Question_update,
  Question_create,
} from "../../../api/api";
import {
  Sizes,
  allIcons,
  questionType,
} from "../../../dummyjson/masterSettingsDefaultValues";
import FilesDragAndDrop from "../../File-Uploader/FileUploader";
import LanguageDropdown from "../../Common/Lang-dropdown/Langselect";
import "./AddEditSettingspopup.scss";
import mobileIcon from "../../../assets/svg/DetailsChannel/mobileIcon.svg";
import tabletIcon from "../../../assets/svg/DetailsChannel/tabletIcon.svg";
import tvIcon from "../../../assets/svg/DetailsChannel/TvIcon.svg";
import laptopIcon from "../../../assets/svg/DetailsChannel/webIcon.svg";
import closeIcon from "../../../assets/svg/Assetmanagemant/closeIcon.svg";
import DropDown from "../../Common/DropDown";
import MultiSelectField from "../../Common/MutiSelectChannel";
import AnswerBlock from "../../Common/AnswerBlock";

const AddEditSettingspopup = ({
  handleClose,
  isEditing,
  gridData,
  tab,
  TabChange,
  onlyview,
  openEdit,
  subTab,
}) => {
  const {
    appThemeReducer: { appTheme },
  } = useSelector((state) => state);
  const textareaRef = useRef(null);
  const [deviceList, setDeviceList] = useState([
    {
      deviceName: "Mobile",
      iconPath: mobileIcon,
      isActive: true,
      deviceId: 3,
    },
    {
      deviceName: "Tablet",
      iconPath: tabletIcon,
      isActive: false,
      deviceId: 4,
    },
    {
      deviceName: "TV",
      iconPath: tvIcon,
      isActive: false,
      deviceId: 1,
    },
    {
      deviceName: "Web",
      iconPath: laptopIcon,
      isActive: false,
      deviceId: 2,
    },
  ]);
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [description, setDescription] = useState("");
  const [formLangList, setFormLanguageList] = useState([]);
  const [validForm, setValidForm] = useState("invalid");
  const [activeTab, setActiveTab] = useState("Mobile");
  const [setting_name, setSettingName] = useState("DefaultName");
  const [Code, setCode] = useState(null);
  const [codeprefix, setCodeprefix] = useState("TH-");
  const [size, setISize] = useState(null);
  const [peerGroups, setPeerGroups] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [peerGroup, setPeerGroup] = useState("");
  const [userGroup, setUserGroup] = useState("");
  const [gender, setGender] = useState(2);
  const [avatarGender, setAvatarGender] = useState([]);
  const [language, setLanguage] = useState([]);
  const [catagories, setCatagories] = useState([]);
  const [genre, setGenre] = useState([]);
  const [languagesList, setLanguagesList] = useState([]);
  const [catagoriesList, setCatagoriesList] = useState([]);
  const [genreList, setGenreList] = useState([]);
  const [isImageEmpty, setIsImageEmpty] = useState(isEditing ? false : true);
  const [subHeading, setSubheading] = useState("");
  const [activeQuestionType, setActiveQuestionType] = useState("");
  console.log("gridData", gridData);
  // for example, initializing it with a default value
  const [tabContent, setTabContent] = useState({
    TV: [],
    Web: [],
    Mobile: [],
    Tablet: [],
  });
  const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

  const [uploadedFiles, setUploadedFiles] = useState(deepClone(allIcons));
  const [uploadedFile, setUploadedFile] = useState(deepClone(allIcons));
  const [deleteFile, setdeleteFile] = useState(deepClone(allIcons));
  const [existingImage, setExistingImage] = useState(deepClone(allIcons));
  const [avatarImage, setAvatarImage] = useState("");
  const [avatarImages, setAvatarImages] = useState("");

  const [posterImage, setPosterImage] = useState("");
  const [posterImages, setPosterImages] = useState("");
  const [optionsList, setOptionsList] = useState([]);
  // console.log("grid",gridData, gridData.id)

  const updateUploadedFiles = () => {
    const updated = { ...uploadedFiles };
    if (tab === "Themes") {
      [gridData?.images].forEach((images) => {
        images.forEach((image) => {
          const { sourcePath } = image;
          const size = image?.size;
          const fileType = "poster";
          if (size === "TV") {
            updated.TV[fileType] = { file: sourcePath, size };
          } else if (size === "Web") {
            updated.Web[fileType] = { file: sourcePath, size };
          } else if (size === "Mobile") {
            updated.Mobile[fileType] = { file: sourcePath, size };
          } else if (size === "Tablet") {
            updated.Tablet[fileType] = { file: sourcePath, size };
          }
        });
      });
    } else {
      gridData?.posterImages.forEach((image) => {
        const { size, sourcePath } = image;
        const type = sourcePath.includes("icon") ? "icon" : "poster";

        if (["TV", "Web", "Mobile", "Tablet"].includes(size)) {
          updated[
            size.charAt(0).toUpperCase() + size.slice(1) === "Tv"
              ? "TV"
              : size.charAt(0).toUpperCase() + size.slice(1)
          ][type] = { file: sourcePath, size, type };
        }
      });

      // For iconImages
      gridData?.iconImages.forEach((image) => {
        const { size, sourcePath, iconImageDesc } = image;
        const type = sourcePath.includes("icon") ? "icon" : "poster";
        const icon_type =
          iconImageDesc === "disabled"
            ? "disabled"
            : iconImageDesc === "null" || iconImageDesc === "enabled"
            ? "enabled"
            : "enabled";
        if (["TV", "Web", "Mobile", "Tablet"].includes(size)) {
          updated[
            size.charAt(0).toUpperCase() + size.slice(1) === "Tv"
              ? "TV"
              : size.charAt(0).toUpperCase() + size.slice(1)
          ][type][icon_type] = { file: sourcePath, size, type, icon_type };
        }
      });
    }

    // Iterate through posterImages and iconImages

    // Set the updated state
    setUploadedFiles(updated);
  };

  const existingImages = () => {
    const existImage = { ...existingImage };
    if (tab === "Themes") {
      [gridData?.images].forEach((images) => {
        images.forEach((image) => {
          const { size, sourcePath } = image;
          const fileType = sourcePath.includes("poster") ? "poster" : "poster";
          if (size === "TV") {
            existingImage.TV[fileType] = { file: sourcePath, size };
          } else if (size === "Web") {
            existingImage.Web[fileType] = { file: sourcePath, size };
          } else if (size === "Mobile") {
            existingImage.Mobile[fileType] = { file: sourcePath, size };
          } else if (size === "Tablet") {
            existingImage.Tablet[fileType] = { file: sourcePath, size };
          }
        });
      });
    } else {
      // For posterImages, assuming a default value for iconImageDesc
      gridData?.posterImages.forEach((image) => {
        const { size, sourcePath } = image;
        const fileType = sourcePath.includes("icon") ? "icon" : "poster";
        const target = "enabled"; // Assuming a default value for posterImages

        if (["TV", "Web", "Mobile", "Tablet"].includes(size)) {
          existImage[
            size.charAt(0).toUpperCase() + size.slice(1) === "Tv"
              ? "TV"
              : size.charAt(0).toUpperCase() + size.slice(1)
          ][fileType] = { file: sourcePath, size };
        }
      });

      // For iconImages
      gridData?.iconImages.forEach((image) => {
        const { size, sourcePath, iconImageDesc } = image;
        const fileType = sourcePath.includes("icon") ? "icon" : "poster";
        const target = iconImageDesc === "enabled" ? "enabled" : "disabled";

        if (["TV", "Web", "Mobile", "Tablet"].includes(size)) {
          existImage[
            size.charAt(0).toUpperCase() + size.slice(1) === "Tv"
              ? "TV"
              : size.charAt(0).toUpperCase() + size.slice(1)
          ][fileType][target] = { file: sourcePath, size };
        }
      });
    }

    // Iterate through posterImages and iconImages

    // Set the updated state
    setExistingImage(existImage);
  };

  const getAvatarSelectFieldsData = async () => {
    const peerGroupRes = await getPeerGroups();
    const userGroupRes = await getUserGroup();
    const avatarGenderList = await getAvatarGender();
    setPeerGroups(peerGroupRes?.data);
    setUserGroups(userGroupRes?.data);
    setAvatarGender(avatarGenderList?.data);
  };

  const getPostersSelectFieldsData = async () => {
    const Language_Lists = await Languages_list({
      searchText: "",
      ignorePagination:true
    });
    const Genres_List = await Genres_list({
      searchText: "",
      sortBy: "name",
      sortOrder: "asc",
      ignorePagination:true
    });
    const Categories_List = await Categories_list({
      searchText: "",
      sortBy: "name",
      sortOrder: "asc",
      ignorePagination:true
    });

    setLanguagesList(Language_Lists.content);
    setGenreList(Genres_List.content);
    setCatagoriesList(Categories_List.content);
  };
  const fetchLanguages = async () => {
    try {
      const Language = await Language_Lists();
      if (Language?.status === true && Language.data != []) {
        setFormLanguageList(Language.data);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };
  const [setting_Code, setsetting_Code] = useState(null);
  const Settingname = async (tab) => {
    if (tab === "Themes") {
      setSettingName("Theme");
      setsetting_Code(gridData?.themeCode);
      setCode("themeCode");
      setCodeprefix("TH-");
      setISize(Sizes?.Theme);
    } else if (tab === "Categories") {
      setSettingName("Category");
      setsetting_Code(gridData?.categoryCode);
      setCode("categoryCode");
      setCodeprefix("CT-");
      setISize(Sizes?.Category);
    } else if (tab === "Genres") {
      setSettingName("Genre");
      setsetting_Code(gridData?.genreCode);
      setCode("genreCode");
      setCodeprefix("GN-");
      setISize(Sizes?.Genre);
    } else if (tab === "Languages") {
      await fetchLanguages();
      setSettingName("Language");
      setsetting_Code(gridData?.languageCode);
      setCode("languageCode");
      setCodeprefix("LN-");
      setISize(Sizes?.Languages);
    } else if (tab === "Maturity Ratings") {
      setsetting_Code(gridData?.maturityRatingCode);
      setCode("maturityRatingCode");
      setSettingName("Maturity Rating");
      setCodeprefix("MR-");
    } else if (tab === "Devices") {
      setSettingName("Device");
      setsetting_Code(gridData?.deviceCode);
      setCode("deviceCode");
      setCodeprefix("DV-");
    } else if (tab === "Onboarding") {
      if (subTab === "Avatars") {
        setSettingName("Avatar");
        getAvatarSelectFieldsData();
      }
      if (subTab === "Posters") {
        setSettingName("Poster");
        getPostersSelectFieldsData();
      }
      if (subTab === "Questions") {
        setSettingName("Question");
      }
    }
  };

  useEffect(() => {
    Settingname(tab);

    if (isEditing && gridData) {
      setName(gridData?.name);
      setDescription(gridData?.description);
      setPeerGroup(gridData?.peerGroup?.id);
      setUserGroup(gridData?.userGroup?.id);
      setGender(gridData?.gender?.id);
      setCatagories(gridData?.categories);
      setGenre(gridData?.genres);
      setLanguage(gridData?.audioLanguages);
      // Update state function
      if (setting_Code) {
        setId(setting_Code.replace(new RegExp(`^${codeprefix}`), "").slice(-4));
      }

      if (tab === "Languages") {
        const selectedLanguageName = formLangList.find(
          (lang) => lang.name === gridData?.name
        );
        setName(selectedLanguageName);
      }
      if (tab === "Onboarding" && subTab === "Questions") {
        setName(gridData?.question);
        setActiveQuestionType(gridData?.questionType);
        setOptionsList(gridData?.optionsList);
      }
      // Call the function to update the state
      if (
        tab !== "Maturity Ratings" &&
        tab !== "Devices" &&
        tab !== "Onboarding"
      ) {
        updateUploadedFiles();
        existingImages();
      } else if (tab === "Onboarding") {
        if (subTab === "Avatars") {
          setAvatarImages({ file: gridData?.sourcePath });
        }
        if (subTab === "Posters") {
          setPosterImages({ file: gridData?.sourcePath });
        }
      }
    } else {
      setName("");
      setId("");
      setDescription("");
    }
    setValidForm("invalid");
  }, [tab, setting_Code]);

  useEffect(() => {
    if (!onlyview) {
      formValidate();
    }
  }, [name, id, description, language, catagories, genre, onlyview]);

  const returnId = (data) => {
    return data.map((item) => item.id);
  };

  const addSettings = async () => {
    let updated = false;
    let Add = false;
    let settingname = "";

    if (isEditing) {
      const newData = new FormData();

      if (
        tab !== "Maturity Ratings" &&
        tab !== "Devices" &&
        tab !== "Onboarding"
      ) {
        newData.append("id", gridData?.id);
        newData.append(Code, codeprefix + id);
        // newData.append("name", name);
        newData.append("name", tab !== "Languages" ? name : name.name);
        newData.append("description", description);
        let index = 0;
        let deleteindex = 0;
        let listingindex = 0;

        for (const [type, images] of Object.entries(uploadedFile)) {
          for (const [category, fileData] of Object.entries(images)) {
            const file = fileData.file;
            const size = fileData.size;
            const iconfile = fileData?.enabled?.file;
            const icondfile = fileData?.disabled?.file;

            if (file || icondfile || iconfile) {
              if (tab === "Themes") {
                newData.append(`uploadThemeImageList[${index}].size`, size);
                newData.append(
                  `uploadThemeImageList[${index}].multipartFile`,
                  file
                );
                index++;
              } else {
                if (category === "poster") {
                  newData.append(`uploadImageList[${index}].size`, size);
                  newData.append(
                    `uploadImageList[${index}].multipartFile`,
                    file
                  );
                  newData.append(`uploadImageList[${index}].type`, "poster");
                  newData.append(
                    `uploadImageList[${index}].iconImageDesc`,
                    "enabled"
                  );
                  index++;
                } else if (category === "icon") {
                  // Accessing icon data properly within the icon category
                  const enabledIcon = fileData.enabled;
                  const disabledIcon = fileData.disabled;

                  // Assuming 'enabled' and 'disabled' are keys containing icon data
                  if (enabledIcon && enabledIcon.file) {
                    const fileType = enabledIcon.file;
                    const sizeType = enabledIcon.size;

                    newData.append(`uploadImageList[${index}].size`, sizeType);
                    newData.append(
                      `uploadImageList[${index}].multipartFile`,
                      fileType
                    );
                    newData.append(`uploadImageList[${index}].type`, "icon");
                    newData.append(
                      `uploadImageList[${index}].iconImageDesc`,
                      "enabled"
                    );

                    index++;
                  }

                  if (disabledIcon && disabledIcon.file) {
                    const fileType = disabledIcon.file;
                    const sizeType = disabledIcon.size;

                    newData.append(`uploadImageList[${index}].size`, sizeType);
                    newData.append(
                      `uploadImageList[${index}].multipartFile`,
                      fileType
                    );
                    newData.append(`uploadImageList[${index}].type`, "icon");
                    newData.append(
                      `uploadImageList[${index}].iconImageDesc`,
                      "disabled"
                    );
                    index++;
                  }
                }
              }
            }
            // Increment the index counter for the next file
          }
        }

        for (const [type, images] of Object.entries(deleteFile)) {
          for (const [category, fileData] of Object.entries(images)) {
            const file = fileData.file;
            const size = fileData.size;
            const iconfile = fileData?.enabled?.file;
            const icondfile = fileData?.disabled?.file;
            if (file || icondfile || iconfile) {
              if (tab === "Themes") {
                newData.append(`deleteImageList[${deleteindex}].size`, size);
                newData.append(
                  `deleteImageList[${deleteindex}].sourcePath`,
                  file
                );
                deleteindex++;
              } else {
                if (category === "poster") {
                  newData.append(`deleteImageList[${deleteindex}].size`, size);
                  newData.append(
                    `deleteImageList[${deleteindex}].sourcePath`,
                    file
                  );
                  newData.append(
                    `deleteImageList[${deleteindex}].type`,
                    "poster"
                  );
                  newData.append(
                    `deleteImageList[${deleteindex}].iconImageDesc`,
                    "enabled"
                  );
                  deleteindex++;
                } else if (category === "icon") {
                  // Accessing icon data properly within the icon category
                  const enabledIcon = fileData.enabled;
                  const disabledIcon = fileData.disabled;

                  // Assuming 'enabled' and 'disabled' are keys containing icon data
                  if (enabledIcon && enabledIcon.file) {
                    const fileType = enabledIcon.file;
                    const sizeType = enabledIcon.size;

                    newData.append(
                      `deleteImageList[${deleteindex}].size`,
                      sizeType
                    );
                    newData.append(
                      `deleteImageList[${deleteindex}].sourcePath`,
                      fileType
                    );
                    newData.append(
                      `deleteImageList[${deleteindex}].type`,
                      "icon"
                    );
                    newData.append(
                      `deleteImageList[${deleteindex}].iconImageDesc`,
                      "enabled"
                    );

                    deleteindex++;
                  }

                  if (disabledIcon && disabledIcon.file) {
                    const fileType = disabledIcon.file;
                    const sizeType = disabledIcon.size;

                    newData.append(
                      `deleteImageList[${deleteindex}].size`,
                      sizeType
                    );
                    newData.append(
                      `deleteImageList[${deleteindex}].sourcePath`,
                      fileType
                    );
                    newData.append(
                      `deleteImageList[${deleteindex}].type`,
                      "icon"
                    );
                    newData.append(
                      `deleteImageList[${deleteindex}].iconImageDesc`,
                      "disabled"
                    );
                    deleteindex++;
                  }
                }
              }
            }
          }
        }

        for (const [type, images] of Object.entries(existingImage)) {
          for (const [category, fileData] of Object.entries(images)) {
            const file = fileData.file;
            const size = fileData.size;
            const iconfile = fileData?.enabled?.file;
            const icondfile = fileData?.disabled?.file;

            if (file || icondfile || iconfile) {
              if (tab === "Themes") {
                newData.append(
                  `listExistingAttachedImages[${listingindex}].size`,
                  size
                );
                newData.append(
                  `listExistingAttachedImages[${listingindex}].sourcePath`,
                  file
                );
                listingindex++;
              } else {
                if (category === "poster") {
                  newData.append(
                    `listExistingImage[${listingindex}].size`,
                    size
                  );
                  newData.append(
                    `listExistingImage[${listingindex}].sourcePath`,
                    file
                  );
                  newData.append(
                    `listExistingImage[${listingindex}].type`,
                    "poster"
                  );
                  newData.append(
                    `listExistingImage[${listingindex}].iconImageDesc`,
                    "enabled"
                  );
                  listingindex++;
                } else if (category === "icon") {
                  // Accessing icon data properly within the icon category
                  const enabledIcon = fileData.enabled;
                  const disabledIcon = fileData.disabled;

                  // Assuming 'enabled' and 'disabled' are keys containing icon data
                  if (enabledIcon && enabledIcon.file) {
                    const fileType = enabledIcon.file;
                    const sizeType = enabledIcon.size;

                    newData.append(
                      `listExistingImage[${listingindex}].size`,
                      sizeType
                    );
                    newData.append(
                      `listExistingImage[${listingindex}].sourcePath`,
                      fileType
                    );
                    newData.append(
                      `listExistingImage[${listingindex}].type`,
                      "icon"
                    );
                    newData.append(
                      `listExistingImage[${listingindex}].iconImageDesc`,
                      "enabled"
                    );
                    listingindex++;
                  }
                  if (disabledIcon && disabledIcon.file) {
                    const fileType = disabledIcon.file;
                    const sizeType = disabledIcon.size;

                    newData.append(
                      `listExistingImage[${listingindex}].size`,
                      sizeType
                    );
                    newData.append(
                      `listExistingImage[${listingindex}].sourcePath`,
                      fileType
                    );
                    newData.append(
                      `listExistingImage[${listingindex}].type`,
                      "icon"
                    );
                    newData.append(
                      `listExistingImage[${listingindex}].iconImageDesc`,
                      "disabled"
                    );
                    listingindex++;
                  }
                }
              }
            }
          }
        }
      } else if (tab === "Onboarding") {
        if (subTab === "Avatars") {
          newData.append("name", name);
          newData.append("peerGroupId", peerGroup);
          newData.append("userGroupId", userGroup);
          newData.append("genderId", gender);
          if (avatarImage) {
            newData.append(`file`, avatarImage);
          } else if (avatarImages?.file) {
            newData.append("sourcePath", avatarImages?.file);
          } else {
            toast.error("Avatar image is required.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000,

              style: { color: "#333333", fontWeight: "bold" },
            });
          }
        } else if (subTab === "Posters") {
          newData.append("name", name);
          newData.append("languageIds", returnId(language));
          newData.append("categoryIds", returnId(catagories));
          newData.append("genreIds", returnId(genre));
          if (posterImage) {
            newData.append(`file`, posterImage);
          } else if (posterImages?.file) {
            newData.append("sourcePath", posterImages?.file);
          } else {
            toast.error("Poster image is required.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000,
              style: { color: "#333333", fontWeight: "bold" },
            });
          }
        }
      } else {
        const newData = {
          id: gridData?.id,
          [Code]: codeprefix + id,
          name: name,
          description: description,
        };
        if (tab === "Maturity Ratings") {
          updated = await MatuarityRatings_update(newData);
          settingname = "maturity ratings";
        } else if (tab === "Devices") {
          updated = await Devices_update(newData);
          settingname = "device";
        }
      }

      closePopup();

      if (tab === "Themes") {
        updated = await Theme_update(newData);
        settingname = "theme";
      } else if (tab === "Categories") {
        updated = await Categories_update(newData);
        settingname = "category";
      } else if (tab === "Genres") {
        updated = await Genres_update(newData);
        settingname = "genre";
      } else if (tab === "Languages") {
        updated = await Languages_update(newData);
        settingname = "language";
      } else if (tab === "Onboarding") {
        if (subTab === "Avatars") {
          updated = await Avatar_update(newData, gridData?.id);
          settingname = "avatar";
        }
        if (subTab === "Posters") {
          updated = await Poster_update(newData, gridData?.id);
          settingname = "poster";
        }
        if (subTab === "Questions") {
          updated = await Question_update(newData, gridData?.id);
          settingname = "question";
        }
      }

      if (updated?.status === 200) {
        toast.success(updated?.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
          style: { color: "#333333", fontWeight: "bold" },
        });
        // theme_ListDetail();
      } else {
        toast.error("Something went wrong, please try after sometime", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
          style: { color: "#333333", fontWeight: "bold" },
        });
      }
    } else {
      const newData = new FormData();
      if (
        tab !== "Maturity Ratings" &&
        (tab !== "Devices") & (tab !== "Onboarding")
      ) {
        newData.append(Code, codeprefix + id);
        newData.append("name", tab !== "Languages" ? name : name.name);
        newData.append("description", description);
        let index = 0;
        let posterindex = 0;

        // Initialize the index counter

        for (const [type, images] of Object.entries(uploadedFile)) {
          for (const [category, fileData] of Object.entries(images)) {
            const file = fileData.file;
            const size = fileData.size;
            const icon_type = fileData.icon_type;
            const iconfile = fileData?.enabled?.file;
            const icondfile = fileData?.disabled?.file;

            if (file || icondfile || iconfile) {
              if (tab === "Themes") {
                newData.append(`themeImageList[${index}].size`, size);
                newData.append(`themeImageList[${index}].multipartFile`, file);
                index++;
              } else {
                if (category === "icon") {
                  if (fileData?.enabled?.icon_type === "enabled") {
                    const iconfile = fileData.enabled.file;
                    const iconsize = fileData.enabled.size;
                    const iconicon_type = fileData.enabled.icon_type;

                    newData.append(`iconImages[${index}].size`, iconsize);
                    newData.append(
                      `iconImages[${index}].multipartFile`,
                      iconfile
                    );
                    newData.append(`iconImages[${index}].type`, "icon");
                    newData.append(
                      `iconImages[${index}].iconImageDesc`,
                      iconicon_type
                    );
                    index++;
                  }
                }
                if (category === "icon") {
                  if (fileData?.disabled?.icon_type === "disabled") {
                    const iconfile = fileData?.disabled.file;
                    const iconsize = fileData?.disabled.size;
                    const iconicon_type = fileData?.disabled.icon_type;

                    newData.append(`iconImages[${index}].size`, iconsize);
                    newData.append(
                      `iconImages[${index}].multipartFile`,
                      iconfile
                    );
                    newData.append(`iconImages[${index}].type`, "icon");
                    newData.append(
                      `iconImages[${index}].iconImageDesc`,
                      iconicon_type
                    );

                    index++;
                  }
                }
                if (category === "poster") {
                  newData.append(`posterImages[${posterindex}].size`, size);
                  newData.append(
                    `posterImages[${posterindex}].multipartFile`,
                    file
                  );
                  newData.append(`posterImages[${posterindex}].type`, "poster");

                  posterindex++;
                }
              }
            }
          }
        }
      } else if (tab === "Onboarding") {
        if (subTab === "Avatars") {
          newData.append("name", name);
          newData.append("peerGroupId", peerGroup);
          newData.append("userGroupId", userGroup);
          newData.append("genderId", gender);
          newData.append(`file`, avatarImage);
        } else if (subTab === "Posters") {
          newData.append("name", name);
          newData.append("languageIds", returnId(language));
          newData.append("categoryIds", returnId(catagories));
          newData.append("genreIds", returnId(genre));
          newData.append(`file`, posterImage);
        } else {
          //Question values to be set
        }
      } else {
        const newData = {
          [Code]: codeprefix + id,
          name: name,
          description: description,
        };
        if (tab === "Maturity Ratings") {
          Add = await MatuarityRatings_create(newData);
          settingname = "maturity rating";
        } else if (tab === "Devices") {
          Add = await Devices_create(newData);
          settingname = "device";
        }
      }

      if (tab === "Themes") {
        Add = await Theme_create(newData);
        settingname = "theme";
      } else if (tab === "Categories") {
        Add = await Categories_create(newData);
        settingname = "category";
      } else if (tab === "Genres") {
        Add = await Genres_create(newData);
        settingname = "genre";
      } else if (tab === "Languages") {
        Add = await Languages_create(newData);
        settingname = "language";
      } else if (tab === "Onboarding") {
        if (subTab === "Posters") {
          Add = await Poster_create(newData);
          settingname = "poster";
        }
        if (subTab === "Avatars") {
          Add = await Avatar_create(newData);
          settingname = "avatar";
        }
        if (subTab === "Questions") {
          Add = await Question_create(newData);
          settingname = "question";
        }
      }
      closePopup();
      if (Add?.status === 201) {
        handleTabChange(activeTab);
        toast.success(Add.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
          style: { color: "#333333", fontWeight: "bold" },
        });
        // theme_ListDetail();
      } else {
        toast.error("Something went wrong, try after some time", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
          style: { color: "#333333", fontWeight: "bold" },
        });
      }
    }

    setTimeout(() => {
      TabChange(tab, "", "");
    }, 1000);
  };
  const changeHandler = (e, imagetype, imageCategory, icontype) => {
    const imageFile = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const file = {
        file: reader.result,
        size: imagetype,
        type: imageCategory,
        icon_type: icontype ? icontype : null,
      };
      if (imageCategory === "avatar") {
        setAvatarImages(file);
        const filename = imageFile.name.replace(/\.[^/.]+$/, "");
        setIsImageEmpty(false);
        setName(filename);
      } else if (imageCategory === "masterSettingposter") {
        setPosterImages(file);
        const filename = imageFile.name.replace(/\.[^/.]+$/, "");
        setIsImageEmpty(false);
        setName(filename);
      } else {
        setUploadedFiles((prevUploadedFiles) => ({
          ...prevUploadedFiles,
          [imagetype]: {
            ...prevUploadedFiles[imagetype],
            [imageCategory]: {
              ...prevUploadedFiles[imagetype][imageCategory],
              ...(imageCategory === "poster" ? file : { [icontype]: file }),
            },
          },
        }));
      }
    };
    reader.readAsDataURL(imageFile); // Read the file as a data URL
    createchangeHandler(e, imagetype, imageCategory, icontype);
  };
  const createchangeHandler = (e, imagetype, imageCategory, icontype) => {
    const file = e.target.files[0];
    const files = {
      file: file,
      size: imagetype,
      icon_type: icontype ? icontype : "enabled",
      type: imageCategory,
    };

    if (imageCategory === "avatar") {
      setAvatarImage(e.target.files[0]);
    } else if (imageCategory === "masterSettingposter") {
      setPosterImage(e.target.files[0]);
    } else {
      setUploadedFile((prevUploadedFiles) => ({
        ...prevUploadedFiles,
        [imagetype]: {
          ...prevUploadedFiles[imagetype],
          [imageCategory]: {
            ...prevUploadedFiles[imagetype][imageCategory],
            ...(imageCategory === "poster" ? files : { [icontype]: files }),
          },
        },
      }));
    }
  };

  const delete_poster = (url, imagetype, imageCategory, icontype) => {
    const file = url;
    const files = {
      file: file,
      size: imagetype,
      icon_type: icontype,
      type: imageCategory,
    };
    // if (typeof file === "string" && file.startsWith("platform")) {
    if (imageCategory === "avatar") {
      setAvatarImage("");
      setName("");
    }

    if (imageCategory === "masterSettingposter") {
      setPosterImage("");
      setName("");
    } else {
      if (typeof file === "string" && file.includes("platform")) {
        setdeleteFile((prevUploadedFile) => ({
          ...prevUploadedFile,
          [imagetype]: {
            ...prevUploadedFile[imagetype],
            [imageCategory]: {
              ...prevUploadedFile[imagetype][imageCategory],
              ...(imageCategory === "poster" ? files : { [icontype]: files }),
            },
          },
        }));
      }
    }

    remove_poster(url, imagetype, imageCategory, icontype);
  };

  const remove_poster = (url, imagetype, imageCategory, icontype) => {
    if (imageCategory === "avatar") {
      setAvatarImages("");
      setIsImageEmpty(true);
    }
    if (imageCategory === "masterSettingposter") {
      setPosterImages("");
      setIsImageEmpty(true);
    } else {
      const files = {
        file: null,
        size: null,
        icon_type: null,
        type: null,
      };

      setExistingImage((prevUploadedFile) => ({
        ...prevUploadedFile,
        [imagetype]: {
          ...prevUploadedFile[imagetype],
          [imageCategory]: {
            ...prevUploadedFile[imagetype][imageCategory],
            ...(imageCategory === "poster" ? files : { [icontype]: files }),
          },
        },
      }));
      setUploadedFile((prevUploadedFile) => ({
        ...prevUploadedFile,
        [imagetype]: {
          ...prevUploadedFile[imagetype],
          [imageCategory]: {
            ...prevUploadedFile[imagetype][imageCategory],
            ...(imageCategory === "poster" ? files : { [icontype]: files }),
          },
        },
      }));
      setUploadedFiles((prevUploadedFile) => ({
        ...prevUploadedFile,
        [imagetype]: {
          ...prevUploadedFile[imagetype],
          [imageCategory]: {
            ...prevUploadedFile[imagetype][imageCategory],
            ...(imageCategory === "poster" ? files : { [icontype]: files }),
          },
        },
      }));
    }
  };

  useEffect(() => {
    setId(id);
  }, [id]);
  const closePopup = () => {
    // setRendered(false);
    handleClose();
  };
  const formValidate = () => {
    if (!name || name === null || name === "") {
      setValidForm("invalid");
    } else if (tab !== "Onboarding" && !id) {
      setValidForm("invalid");
    } else if (tab === "Onboarding") {
      if (subTab === "Posters") {
        if (
          language.length === 0 ||
          genre.length === 0 ||
          catagories.length === 0
        ) {
          setValidForm("invalid");
        } else {
          setValidForm("valid");
        }
      } else {
        setValidForm("valid");
      }
    } else {
      setValidForm("valid");
    }
    console.log("validForm", validForm, subTab, tab);
  };

  //   const updateForm = (field, value) => {};
  const handleTabChange = async (tabName) => {
    setActiveTab(tabName);

    if (!tabContent[tabName] || tabContent[tabName].length === 0) {
    }
  };



  return (
    <Modal
      className={`AddEditSettingspopup ${appTheme}`}
      show={true}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isEditing
            ? onlyview
              ? `${setting_name}`
              : `Edit ${setting_name}`
            : `Add New ${setting_name}`}
        </Modal.Title>
        <div onClick={handleClose} style={{ cursor: "pointer" }}>
          <img src={closeIcon} alt="close" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {tab === "Onboarding" && subTab !== "Questions" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {isImageEmpty && (
                <label class="form-label">
                  Upload {setting_name} <span class="requiredField"> *</span>
                </label>
              )}

              <div className=" box-shadow imagesSection">
                <FilesDragAndDrop
                  id="Avatar-poster"
                  imgcategory={
                    setting_name === "Poster" ? "masterSettingposter" : "avatar"
                  }
                  label={`${setting_name} Image`}
                  index={1}
                  size={size?.poster.mobile}
                  uploadedFiles={
                    setting_name === "Poster" ? posterImages : avatarImages
                  }
                  onChangeHandler={changeHandler}
                  deleteimages={delete_poster}
                  imagetype={
                    setting_name === "Poster" ? "MasterSettingPoster" : "Avatar"
                  }
                  edit={onlyview}
                />
              </div>
            </div>
          ) : null}
          <div className="flex">
            <Form.Group className="flex-100">
              <Form.Label>
                Title
                {!onlyview && <span class="requiredField"> *</span>}
              </Form.Label>
              {tab !== "Languages" ? (
                <Form.Control
                  placeholder={"Enter " + setting_name + " name"}
                  type="text"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  readOnly={onlyview}
                />
              ) : (
                <MultiSelectField
                  className="MultiSelectContainer"
                  options={formLangList}
                  displayValue="name"
                  selectedValues={name ? name : ""}
                  placeholder="Select Languages"
                  section="language"
                  isDisabled={onlyview}
                  setId={setId}
                  setName={setName}
                  onSelect={(event) => {
                    setName(event);
                  }}
                  onRemove={(event) => {
                    setName(event);
                  }}
                />
              )}
            </Form.Group>

            {tab !== "Onboarding" && (
              <Form.Group className="flex-100">
                <Form.Label>
                  ID {!onlyview && <span class="requiredField"> *</span>}{" "}
                  <span> (ex: {codeprefix}XYZ )</span>
                </Form.Label>
                <div className={`idField ${onlyview ? "disable" : ""}`}>
                  {/* <span className="prefixcode pr-0">{codeprefix}</span> */}

                  <Form.Control
                    className="prefixcode"
                    placeholder={codeprefix}
                    type="text"
                    disabled
                  />
                  <Form.Control
                    placeholder={"Enter " + setting_name + " Id"}
                    type="text"
                    className="prefixId"
                    value={id}
                    minLength="3"
                    maxLength="3"
                    onChange={(e) => {
                      setId(e.target.value);
                    }}
                    disabled={isEditing || tab === "Languages"}
                  />
                </div>
              </Form.Group>
            )}
          </div>
          {tab === "Onboarding" ? (
            <>
              <div className="flex dropdownSection">
                {subTab === "Avatars" && (
                  <>
                    {" "}
                    <Form.Group className="flex-50">
                      <Form.Label>
                        Gender{" "}
                        {!onlyview && <span class="requiredField"> *</span>}
                      </Form.Label>

                      <DropDown
                        value={gender}
                        setState={setGender}
                        options={avatarGender}
                        name="Gender"
                        disabled={onlyview}
                      />
                    </Form.Group>
                    <Form.Group className="flex-50">
                      <Form.Label>User Group</Form.Label>

                      <DropDown
                        value={userGroup}
                        setState={setUserGroup}
                        options={userGroups}
                        name="User Group"
                        disabled={onlyview}
                      />
                    </Form.Group>
                    <Form.Group className="flex-50">
                      <Form.Label>Peer Group</Form.Label>

                      <DropDown
                        value={peerGroup}
                        setState={setPeerGroup}
                        options={peerGroups}
                        name="Peer Group"
                        disabled={onlyview}
                      />
                    </Form.Group>
                  </>
                )}
                {subTab === "Posters" && (
                  <>
                    <Form.Group className="flex-50 ">
                      <Form.Label>
                        Languages{" "}
                        {!onlyview && <span class="requiredField"> *</span>}
                      </Form.Label>

                      <MultiSelectField
                        className="MultiSelectContainer"
                        options={languagesList}
                        displayValue="name"
                        selectedValues={language}
                        placeholder="Select Languages"
                        section="onboarding"
                        isDisabled={onlyview}
                        onSelect={(event) => {
                          setLanguage(event);
                        }}
                        onRemove={(event) => {
                          setLanguage(event);
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="flex-50 ">
                      <Form.Label>
                        Catagories{" "}
                        {!onlyview && <span class="requiredField"> *</span>}
                      </Form.Label>

                      <MultiSelectField
                        className="MultiSelectContainer"
                        options={catagoriesList}
                        displayValue="name"
                        selectedValues={catagories}
                        placeholder="Select Catagories"
                        section="onboarding"
                        isDisabled={onlyview}
                        onSelect={(event) => {
                          setCatagories(event);
                        }}
                        onRemove={(event) => {
                          setCatagories(event);
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="flex-50 ">
                      <Form.Label>
                        Genres{" "}
                        {!onlyview && <span class="requiredField"> *</span>}
                      </Form.Label>

                      <MultiSelectField
                        className="MultiSelectContainer"
                        options={genreList}
                        displayValue="name"
                        selectedValues={genre}
                        placeholder="Select Genres"
                        section="onboarding"
                        isDisabled={onlyview}
                        onSelect={(event) => {
                          setGenre(event);
                        }}
                        onRemove={(event) => {
                          setGenre(event);
                        }}
                      />
                    </Form.Group>
                  </>
                )}
                {subTab === "Questions" && (
                  <>
                    <Form.Group className="flex-100">
                      <Form.Label>Subheading</Form.Label>

                      <Form.Control
                        placeholder={"No Subheading"}
                        type="text"
                        value={gridData.subheading}
                        readOnly={onlyview}
                      />
                    </Form.Group>
                    <Form.Group className="flex-100">
                      <Form.Label>Type</Form.Label>

                      <ul className="questiontypes">
                        {questionType.map((val) => {
                          return (
                            <li
                              className={`${
                                activeQuestionType === val.value
                                  ? "activeQuestionType"
                                  : ""
                              }`}
                              key={val.value}
                              value={activeQuestionType}
                            >
                              {val.name}
                            </li>
                          );
                        })}
                      </ul>
                    </Form.Group>

                    <Form.Group className="flex-100">
                      <Form.Label className="answerLabel">
                        <div>Answer Options</div>{" "}
                        <div className="iconsCheckbox">
                          <input
                            type="checkbox"
                            checked={gridData?.includeIcons}
                            readOnly
                          />
                          <span
                            className={`${
                              gridData?.includeIcons
                                ? "checkmark"
                                : "notcheckmark"
                            } `}
                          ></span>
                          Include Icons
                        </div>
                      </Form.Label>
                      <div className="optionsList">
                        <ul>
                          {(gridData?.optionsList).map((option,index) => {
                            console.log("option",option)
                            return (
                              <AnswerBlock
                                includeIcon={gridData?.includeIcons}
                                data={option}
                                index={index + 1}
                              />
                            );
                          })}
                        </ul>
                      </div>
                    </Form.Group>
                  </>
                )}
              </div>
            </>
          ) : null}
          {tab !== "Onboarding" && (
            <div className="flex ">
              <Form.Group className="flex-100 descriptionField">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  placeholder={"Enter " + setting_name + " Description"}
                  as="textarea"
                  rows={2}
                  ref={textareaRef}
                  value={description}
                  onChange={(e) => {
                    const textarea = textareaRef.current;
                    textarea.style.height = textarea.scrollHeight + "px";
                    setDescription(e.target.value);
                  }}
                  readOnly={onlyview}
                  maxLength="1024"
                  className="customTextArea"
                  style={{
                    height: "auto",
                    maxHeight: "100px",
                    minHeight: "80px",
                    // overflowY: description.length > 400 ? "auto" : "hidden"
                  }}
                />
                <div className="field-length">
                  <span>{description.length}/1024</span>
                </div>
              </Form.Group>
            </div>
          )}

          {tab !== "Maturity Ratings" &&
          tab !== "Devices" &&
          tab !== "Onboarding" ? (
            <div className="">
              <div className="">
                <label class="form-label">Images</label>

                <div className="file-uploader-device-list">
                  <ul>
                    {deviceList.map((device) => {
                      return (
                        <li
                          key={device.deviceId}
                          className={
                            activeTab === device.deviceName ? "active" : ""
                          }
                          onClick={() => {
                            handleTabChange(device.deviceName);
                          }}
                        >
                          <img src={device.iconPath} alt="icon" />
                          <span>{device.deviceName}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              {activeTab === "Mobile" && (
                <div className=" box-shadow imagesSection">
                  <FilesDragAndDrop
                    id="Mobile-poster"
                    imgcategory="poster"
                    label={"Poster"}
                    index={1}
                    size={size?.poster.mobile}
                    uploadedFiles={uploadedFiles}
                    onChangeHandler={changeHandler}
                    deleteimages={delete_poster}
                    imagetype="Mobile"
                    edit={onlyview}
                    tab={tab}
                  />
                  {tab !== "Themes" &&
                    tab !== "Languages" &&
                    tab !== "Genres" && (
                      <>
                        <FilesDragAndDrop
                          // id="Mobile-icon"
                          imgcategory="icon"
                          label={"Enabled Icon"}
                          index={0}
                          size={size?.icon.mobile}
                          uploadedFiles={uploadedFiles}
                          onChangeHandler={changeHandler}
                          deleteimages={delete_poster}
                          imagetype="Mobile"
                          edit={onlyview}
                          icontype={"enabled"}
                        />
                        <FilesDragAndDrop
                          // id="Mobile-icon"
                          imgcategory="icon"
                          label={"Disabled Icon"}
                          index={0}
                          size={size?.icon.mobile}
                          uploadedFiles={uploadedFiles}
                          onChangeHandler={changeHandler}
                          deleteimages={delete_poster}
                          imagetype="Mobile"
                          edit={onlyview}
                          icontype={"disabled"}
                        />
                      </>
                    )}

                  {/* <div ref={drop} className='FilesDragAndDrop'></div> */}
                </div>
              )}
              {activeTab === "TV" && (
                <div className=" box-shadow imagesSection">
                  <FilesDragAndDrop
                    id="tv-poster"
                    imgcategory="poster"
                    label={"Poster"}
                    index={1}
                    size={size?.poster.tv}
                    uploadedFiles={uploadedFiles}
                    onChangeHandler={changeHandler}
                    deleteimages={delete_poster}
                    imagetype="TV"
                    // validsize={"16 x 14"}
                    edit={onlyview}
                  />

                  {tab !== "Themes" &&
                    tab !== "Languages" &&
                    tab !== "Genres" && (
                      <>
                        <FilesDragAndDrop
                          id="tv-icon"
                          imgcategory="icon"
                          label={"Enabled icon"}
                          index={0}
                          size={size?.icon.tv}
                          uploadedFiles={uploadedFiles}
                          onChangeHandler={changeHandler}
                          deleteimages={delete_poster}
                          imagetype="TV"
                          edit={onlyview}
                          icontype={"enabled"}
                        />
                        <FilesDragAndDrop
                          id="tv-icon"
                          imgcategory="icon"
                          label={"Disabled icon"}
                          index={0}
                          size={size?.icon.tv}
                          uploadedFiles={uploadedFiles}
                          onChangeHandler={changeHandler}
                          deleteimages={delete_poster}
                          imagetype="TV"
                          edit={onlyview}
                          icontype={"disabled"}
                        />
                      </>
                    )}

                  {/* <div ref={drop} className='FilesDragAndDrop'></div> */}
                </div>
              )}
              {activeTab === "Web" && (
                <div className=" box-shadow imagesSection">
                  <FilesDragAndDrop
                    id="Web-poster"
                    imgcategory="poster"
                    label={"Poster"}
                    index={1}
                    size={size?.poster.web}
                    uploadedFiles={uploadedFiles}
                    onChangeHandler={changeHandler}
                    deleteimages={delete_poster}
                    imagetype="Web"
                    edit={onlyview}
                  />
                  {tab !== "Themes" &&
                    tab !== "Languages" &&
                    tab !== "Genres" && (
                      <>
                        <FilesDragAndDrop
                          id="Web-icon"
                          imgcategory="icon"
                          label={"Enabled icon"}
                          index={0}
                          size={size?.icon.web}
                          uploadedFiles={uploadedFiles}
                          onChangeHandler={changeHandler}
                          deleteimages={delete_poster}
                          imagetype="Web"
                          edit={onlyview}
                          icontype={"enabled"}
                        />
                        <FilesDragAndDrop
                          id="Web-icon"
                          imgcategory="icon"
                          label={"Disabled icon"}
                          index={0}
                          size={size?.icon.web}
                          uploadedFiles={uploadedFiles}
                          onChangeHandler={changeHandler}
                          deleteimages={delete_poster}
                          imagetype="Web"
                          edit={onlyview}
                          icontype={"disabled"}
                        />
                      </>
                    )}

                  {/* <div ref={drop} className='FilesDragAndDrop'></div> */}
                </div>
              )}

              {activeTab === "Tablet" && (
                <div className=" box-shadow imagesSection">
                  <FilesDragAndDrop
                    id="Tablet-poster"
                    imgcategory="poster"
                    label={"Poster"}
                    index={1}
                    size={size?.poster.tablet}
                    uploadedFiles={uploadedFiles}
                    onChangeHandler={changeHandler}
                    imagetype="Tablet"
                    edit={onlyview}
                    deleteimages={delete_poster}
                  />
                  {tab !== "Themes" &&
                    tab !== "Languages" &&
                    tab !== "Genres" && (
                      <>
                        <FilesDragAndDrop
                          id="Tablet-icon"
                          imgcategory="icon"
                          label={"Enabled icon"}
                          index={0}
                          size={size?.icon.tablet}
                          uploadedFiles={uploadedFiles}
                          onChangeHandler={changeHandler}
                          imagetype="Tablet"
                          edit={onlyview}
                          icontype={"enabled"}
                          deleteimages={delete_poster}
                        />
                        <FilesDragAndDrop
                          id="Tablet-icon"
                          imgcategory="icon"
                          label={"Disabled icon"}
                          index={0}
                          size={size?.icon.tablet}
                          uploadedFiles={uploadedFiles}
                          onChangeHandler={changeHandler}
                          imagetype="Tablet"
                          edit={onlyview}
                          icontype={"disabled"}
                          deleteimages={delete_poster}
                        />
                      </>
                    )}

                  {/* <div ref={drop} className='FilesDragAndDrop'></div> */}
                </div>
              )}
            </div>
          ) : null}
        </Form>
      </Modal.Body>
      {
       (tab !== "Onboarding" || (tab === "Onboarding" && subTab !== "Questions")) && <Modal.Footer>
          <Button className="Cancel" onClick={closePopup}>
            Cancel
          </Button>
          {
            <Button
              disabled={validForm === "valid" || onlyview ? false : true}
              className={`Add`}
              onClick={onlyview ? openEdit : addSettings}
            >
              {isEditing ? (onlyview ? "Edit" : "Update") : "Add"}
            </Button>
          }
        </Modal.Footer>
      }
    </Modal>
  );
};

export default AddEditSettingspopup;
